import { browser, ua } from '../../../../util/user-agent';
import { app } from '../../../app';

app.factory('Authenticator', Authenticator);

/** @ngInject */
function Authenticator($resource) {
    return $resource('app/rest/authenticators/:id', {
        id : '@id'
    }, {
        'query' : {
            method : 'GET',
            isArray : true
        },
        'get' : {
            method : 'GET'
        },
        'getTracker' : {
            method : 'GET',
            url : 'app/rest/authenticators/tracker/:id',
            isArray : false,
            params : {
                id : '@id',
            },
            transformResponse: function(data, headers){
                return { tracker: data };
            }
        }
    });
}



app.factory('ExtentionManaging', ExtentionManaging);

/** @ngInject */
function ExtentionManaging($window) {

  function installExtension() {
    
      if (ua.isChrome()) {
        
        var installUrl = `${window.env.clientDownloadUrl.chromeExtension}`;
        $window.open(installUrl, '_blank');
        
      } else if (ua.isOpera()) {
        
        var installUrl = 'https://addons.opera.com/en/extensions/details/saaspass-single-sign-on/';
        $window.open(installUrl, '_blank');

      } else if (ua.isSafari()) {
        
        var installUrl = 'https://www.saaspass.com/assets/Extensions/SAASPASS.safariextz';
        $window.open(installUrl, '_blank');

      } else if (ua.isFirefox()) {
        
        var installUrl = 'https://addons.mozilla.org/en-US/firefox/addon/saaspass-single-sign-on/';
        $window.open(installUrl, '_blank');
        
    } else {
          console.warn(`The SAASPASS Extension in not supported in ${browser.name}.`);
    }

}

return {
    installExtension : installExtension,
}

}

app.factory('SsoFactory', SsoFactory);

/** @ngInject */
function SsoFactory(Authenticator, $q) {
    var authenticatorsSSO = function(authenticator) {
        var defered = $q.defer();

        if (authenticator.publicService.ssoSupported) {
            if (authenticator.ssoEnabled) {
                var id = authenticator.id;
                
                if (document.getElementById("saaspass-extension-info")) {
                    Authenticator.getTracker({ id }, ({ tracker }) =>
                        window.postMessage(
                            {action: "loginWithTracker", tracker, newTab: true},
                            "*"
                        )
                    );
                    return;
                }

                var hasExtensionInstalled201 = document.getElementById('extension-is-installed-v2.0.1') != null;
                var hasExtensionInstalled210 = document.getElementById('extension-is-installed-v2.1.0') != null;
                
                if (hasExtensionInstalled201) {
                    Authenticator.get({
                        id : id
                    }, function(data) {
                        delete data["$promise"];
                        delete data["$resolved"];
                        
                        if (ua.isChrome() || ua.isOpera()) {
                            
                            const extensionId = ua.isChrome()
                                ? window.env.extensionIds.chrome
                                : window.env.extensionIds.opera;

                            chrome.runtime.sendMessage(extensionId, {
                                data : data,
                                message : "loginAuthenticator"
                            }, function(response) {
                                if (!response) {
                                    console.log("Error extension");
                                    alert("The SAASPASS Extension in not installed or disabled.");
                                } else {
                                    console.log("Message sent to extension id: " + window.env.extensionIds.chrome);
                                }
                            });
                            
                        } else if (ua.isSafari() || ua.isFirefox()) {
                            
                            window.postMessage({
                                instructions : data,
                                message : "loginAuthenticator"
                            }, "*");

                        }
                        
                        defered.resolve(data);
                    });
                }
                else if (hasExtensionInstalled210) {
                  
                        // new implementation for Chrome, Firefox and Opera is tracker based
                        Authenticator.getTracker({
                            id : id
                        }, function(data) {
                            // console.log(data);
                            delete data["$promise"];
                            delete data["$resolved"];
 
                            if(ua.isFirefox()){
                                
                                // Firefox does not support externally_connectable Manifest key
                                window.postMessage({
                                    direction: "from-page-script",
                                    message: data
                                  }, "*");
                            }
                            else{
                                
                                const extensionId = ua.isChrome() ? 
                                        window.env.extensionIds.chrome
                                      : window.env.extensionIds.opera;
                                
                                chrome.runtime.sendMessage(extensionId, {
                                    data : data,
                                    message : "loginWithTracker"
                                }, function(response) {
                                    if (!response) {
                                        console.log("SAASPASS extension not responding.");
                                        alert("The SAASPASS Extension in not installed or disabled.");
                                    } else {
                                        console.log("Message sent to extension with id: " + extensionId);
                                    }
                                });
                            }                      
                            defered.resolve(data);
                        });
                    
                }else{
                     console.warn('Please check your SAASPASS extension. Extension can be not supported, disabled or not installed in '+ browser.name + '.')
                     alert('Please check your SAASPASS extension. Extension can be not supported, disabled or not installed in ' + browser.name + '.');
                }

            }
        } else {
            const isCustom = (authenticator.publicService || {}).slug === 'other';
            const customUrlRequired = !!(authenticator.publicService || {}).urlRequired;
            const serviceUrl = (authenticator.publicService || {}).serviceUrl;
            const customUrl = (authenticator.customLoginUrl || {}).serviceLoginUrl;
            const location = isCustom || customUrlRequired ? customUrl : serviceUrl;
            window.open(location, '_blank');
            defered.resolve("");
        }
        return defered.promise;
    }
    
    return {
        authenticatorsSSO : authenticatorsSSO
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/public-user-accounts/authenticators.service.js